<template>
  <div
      v-if="!isWC()"
      class="  text-white position-relative"
      :class="!isSushi ? 'introimg headersize' : 'introImgSushi headerSizeSushi' "
      v-bind:style="[headAbsolute != '' ? { 'background-image': isSushi ? sushiImg :  headAbsolute } : '']"
  >
    <div
        class="position-absolute w-100 h-100 d-flex justify-content-center align-items-center flex-column bg-opacity"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "IntroHeader",
  props : {
    isSushi : {
      type : Boolean
    }
  },
  computed: {
    ...mapGetters(["hqDoc"]),
    headAbsolute() {
      if (this.hqDoc && this.hqDoc.ProfileImage != "") {
        return `url(${this.hqDoc.ProfileImage})`;
      } else {
        return "";
      }
    },
    sushiImg: require("../../assets/images/sushiHub/homeBanner.png")
  }
};
</script>
